<template>
	<div class="wrapper">
		<v-container text-xs-center grid-list-sm>
			<v-layout justify-center row wrap>
				<v-flex xs12 sm12 md5>
					<v-text-field
						persistent-hint
						hint="Enter Text to Filter by"
						color="yellow darken-3"
						label="Filter Text"
						v-model="filterText"
					></v-text-field>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center grid-list-sm>
			<v-list two-line v-if="endDisplayPointsList.length">
				<template v-for="(item, index) in endDisplayPointsList">
					<v-list-tile :key="index+'avatar'" avatar>
						<v-list-tile-avatar>
							<v-icon :color="getColor(item)">wb_cloudy</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{ item.name }}</v-list-tile-title>
							<v-list-tile-sub-title>{{ item.method }}</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action>
							<v-btn
								v-if="checkEndpointStatus(item)"
								icon
								ripple
								@click="openModal(item)"
							>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon color="grey lighten-1" v-on="on"
											>arrow_forward</v-icon
										>
									</template>
									<span>Open Request Editor</span>
								</v-tooltip>
							</v-btn>
							<v-btn v-else icon ripple @click="makeAPICall(item)">
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon color="grey lighten-1" v-on="on">send</v-icon>
									</template>
									<span>Make Request</span>
								</v-tooltip>
							</v-btn>
						</v-list-tile-action>
					</v-list-tile>
					<v-divider v-if="index < endDisplayPointsList.length - 1" :key="index"></v-divider>
				</template>
			</v-list>
			<div v-else>
				<img style="max-width: 100%;" src="../../assets/empty.svg" alt />
			</div>
		</v-container>
		<Request v-if="requestModal" />
	</div>
</template>

<script>
import Request from './request';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import constants from '@/api';
import Fuse from 'fuse.js';
export default {
	data() {
		return {
			endPointsList: require('@/components/end-points.js'),
			endDisplayPointsList: require('@/components/end-points.js'),
			fuse: {},
			filterText: '',
			fileExtensions: [
				{ text: 'All', value: false },
				...require('../../components/extensions.json'),
			],
		};
	},
	components: {
		Request,
	},
	created() {
		let options = {
			shouldSort: true,
			threshold: 0.6,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: ['name', 'method'],
		};
		this.fuse = new Fuse(this.endPointsList, options);
	},
	methods: {
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapActions('requests', ['getAPICall', 'postAPICall', 'putAPICall']),
		...mapMutations('requests', ['openRequestModal', 'setSelectedRequest']),
		getColor(item) {
			switch (item.method) {
				case 'POST': {
					return 'orange darken-1';
				}
				case 'GET': {
					return 'green darken-1';
				}
				case 'PUT': {
					return 'purple darken-1';
				}
			}
		},
		openModal(item) {
			this.setSelectedRequest(item);
			this.openRequestModal();
		},
		checkEndpointStatus(item) {
			if (item.queryParams && item.queryParams.length) {
				return true;
			} else if (item.body && Object.keys(item.body).length) {
				return true;
			}
			return false;
		},
		getUrl(item) {
			return `${constants.BASE_URL}${item.url}`;
		},
		makeAPICall(item) {
			if (
				window.confirm(
					`Are you SURE you want to make ${
						item.name
					} API call "${this.userData.name.toUpperCase()}".`
				)
			) {
				switch (item.method) {
					case 'GET': {
						this.getAPICall({ url: this.getUrl(item), params: {} })
							.then(data => {
								this.openSnackbar({
									text: JSON.stringify(data, null, 2),
								});
							})
							.catch(e => {
								this.openSnackbar({
									text: 'Failed to make Request',
								});
							});
						break;
					}
					case 'POST': {
						this.postAPICall({
							url: this.getUrl(item),
							data: {},
						})
							.then(data => {
								this.openSnackbar({
									text: JSON.stringify(data, null, 2),
								});
							})
							.catch(e => {
								this.openSnackbar({
									text: 'Failed to make Request',
								});
							});
						break;
					}
					case 'PUT': {
						this.putAPICall({
							url: this.getUrl(item),
							data: {},
						})
							.then(data => {
								this.openSnackbar({
									text: JSON.stringify(data, null, 2),
								});
							})
							.catch(e => {
								this.openSnackbar({
									text: 'Failed to make Request',
								});
							});
						break;
					}
				}
			}
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'selectedDates', 'userData']),
		...mapGetters('requests', ['requestModal']),
	},
	mounted() {},
	watch: {
		// selectedDates(nv, cv) {},
		filterText(nv) {
			if (nv.length > 0) {
				this.endDisplayPointsList = this.fuse.search(nv);
			} else {
				this.endDisplayPointsList = this.endPointsList;
			}
		},
	},
};
</script>

<style lang="scss" scoped></style>
